export const FD_SDB_TEMPLATE_TOUR_ID = 'sdb-template-tour';
